module.exports = __webpack_public_path__ + "img/nlp.350d4c5d.png";